module.exports = "<!-- Copyright The Linux Foundation and each contributor to LFX. -->\n<!-- SPDX-License-Identifier: MIT -->\n\n<div class=\"col p-0\">\n    <app-back-button *ngIf=\"showBackButton\" class=\"mb-3 d-block\"></app-back-button>\n    <img\n        class=\"project-logo mb-3\"\n        src=\"https://s3.amazonaws.com/lfx-project-logos/400x245.png\"\n        alt=\"{{ project?.name }}\"\n    >\n    <h2 class=\"display-4\">{{ project?.name }}</h2>\n    <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/project-column/project-column.component.html
// module id = ./src/app/shared/project-column/project-column.component.html
// module chunks = main